
// src/web/components/search-timeline-page-conditions.jsx

import React from 'react'
import { translate } from 'react-i18next'
import ui from '../../helpers/ui-state'
import Chip from 'react-toolbox/lib/chip'
import Input from './compact-input.jsx'
import Avatar from 'react-toolbox/lib/avatar'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import ConfirmDialog from './confirm-dialog.jsx'
import successButtonTheme from './themes/success-button.css'
import primaryButtonTheme from './themes/primary-button.css'
import { linkUI } from '../../helpers/form-validator'
import moment from 'moment'
import { PropTypes } from 'prop-types'
import context from '../../helpers/context'

const MAX_DISPLAY_COUNT = 10
class SearchConditions extends React.Component {
  showAllUser = () => this.props.updateUI({ showAllUser: !this.props.ui.showAllUser})
  editSearchDrawer = () => this.props.editSearchDrawer()
  render() {
    const {
      t,
      ui,
      preservedQuery,
      updateUI,
      deletePreservedQuery,
      createPreservedQuery,
      editSearchDrawer,
    } = this.props

    const {
      category,
      user_ids,
      users,
      reported_at,
      files_attached,
      liked_by,
      query,
    } = this.props.params

    const queryName = preservedQuery && preservedQuery.name
    const queryText = preservedQuery ? preservedQuery.queryText : query
    const categoryData = preservedQuery ? preservedQuery.category : category
    const filesAttachedData = preservedQuery ? preservedQuery.files_attached : files_attached
    const liked_status = preservedQuery ? preservedQuery.liked_by : liked_by
    const reportedAtData = preservedQuery ? preservedQuery.reported_at : reported_at
    const usersData = preservedQuery ? preservedQuery.users : users

    if (ui.savingQuery)
      return (
        <form style={{ display: 'flex', width: '100%', padding: '0 5px' }}
              onSubmit={(ev)=> { ev.preventDefault(); createPreservedQuery(ui.name) }}>
          <div style={{ width: '100%' }}>
            <Input hasFocus value={ui.name} onChange={linkUI(this, 'name')}/>
          </div>
          <Button type="submit" label={t('label:保存')} primary raised style={{ minWidth: 'auto' }} />
        </form>
      )
    else
      return (
        <div style={{ maxHeight: 160, overflow: 'scroll' }}>
          {preservedQuery &&
          <Button theme={successButtonTheme} raised 
              icon={"edit"}
              label={t("label:検索条件を編集")}
              onClick={this.editSearchDrawer}
              style={{ verticalAlign: 'bottom', margin: '4px 6px 6px' }} />}
          <Button theme={preservedQuery ? primaryButtonTheme : successButtonTheme} raised 
              icon={preservedQuery ? "close" : "add"}
              label={preservedQuery ? t('label:検索条件を削除') : t('label:検索条件を保存')}
              onClick={preservedQuery ? ()=> updateUI({ deleteConfirm: true }) : ()=> updateUI({ savingQuery: true })}
              style={{ verticalAlign: 'bottom', margin: '4px 6px 6px' }} />
          {queryName && <Chip><Avatar icon='save'/>{queryName}</Chip>}
          {queryText && queryText.length > 0 && <Chip><Avatar icon='search'/>{queryText}</Chip>}
          {categoryData== 'diary' && <Chip><Avatar icon="event_note"/>{t('label:日報のみ')}</Chip>}
          {categoryData == 'kpi' && <Chip><Avatar icon="insert_chart"/>{t('label:KPIのみ')}</Chip>}
          {categoryData == 'memo' && <Chip><Avatar icon="assignment"/>{t('label:ノートのみ')}</Chip>}
          {liked_status && <Chip><Avatar icon="search"/>{t('label:いいねした投稿')}</Chip>}
          {filesAttachedData && <Chip><Avatar icon='attachment'/>{t('label:添付ファイル付き')}</Chip>}
          {reportedAtData && <Chip><Avatar icon='date_range'/>{t('label:より後の投稿', { reported_at: moment(reportedAtData).format('LLLL')})}</Chip>}
          {ui.showAllUser && usersData && usersData.length > 0 && _.map(usersData, (user)=>
            <Chip><Avatar image={user.icon_image.thumb_url}/>{user.name}</Chip>
          )}
          {ui.showAllUser && <Button 
            style={{ bottom: 10 }}
            primary
            onClick={this.showAllUser}
            icon='arrow_forward'
            label={t('label:表示を隠す')} />}
          {!ui.showAllUser && usersData && usersData.length > 0 && _.map(usersData.slice(0, MAX_DISPLAY_COUNT), (user, i) => <Chip><Avatar image={user.icon_image.thumb_url}/>{user.name}</Chip>)}
          {!ui.showAllUser && usersData && usersData.length > MAX_DISPLAY_COUNT && <Button 
            style={{ bottom: 10 }}
            primary
            onClick={this.showAllUser}
            icon='arrow_forward'
            label={t('label:他n人', { n: usersData.length - MAX_DISPLAY_COUNT }) + 'を' + t('label:すべて表示')} />}
          {preservedQuery && 
            <ConfirmDialog open={ui.deleteConfirm}
              title={t('label:検索条件を削除してもいいですか', { name: preservedQuery.name })}
              description={t('label:この操作は取り消せません')}
              yesLabel={t('label:削除')}
              noLabel={t('label:取り消し')}
              onYes={()=> { updateUI({ deleteConfirm: false }); deletePreservedQuery(preservedQuery) }}
              onNo={()=> updateUI({ deleteConfirm: false })} />}
        </div>)
  }
}

export default translate()(ui({ state: {
  deleteConfirm: false,
  savingQuery: false,
  showAllUser: false,
  name: (props)=> props.t('label:新しい検索条件')
}})(SearchConditions))



// WEBPACK FOOTER //
// ./src/web/components/search-timeline-page-conditions.jsx